export default [
    {
        name: 'base',
        data: {},
        items:
        [
            // Maps
            { name: 'entrepot1Map', source: '/assets/maps/entrepot1.txt', type: 'map' },
            { name: 'entrepot2Map', source: '/assets/maps/entrepot2.txt', type: 'map' },
            // Models
            { name: 'emptyBoxesModel', source: '/assets/models/boxes/empty_boxes.glb', type: 'model' },
            { name: 'shelfModel', source: '/assets/models/shelf/classic_shelf.glb', type: 'model' },
            { name: 'shelfTargetModel', source: '/assets/models/shelf/classic_shelf.glb', type: 'model' },
            { name: 'forkliftModel', source: '/assets/models/vehicles/forklift_truck.glb', type: 'model' },
            { name: 'forkliftRackModel', source: '/assets/models/vehicles/forklift_rack.glb', type: 'model' },
            { name: 'forkliftWheelLeftModel', source: '/assets/models/vehicles/forklift_wheel_left.glb', type: 'model' },
            { name: 'forkliftWheelRightModel', source: '/assets/models/vehicles/forklift_wheel_right.glb', type: 'model' },
            { name: 'palletTruckModel', source: '/assets/models/vehicles/pallet_truck.glb', type: 'model' },
            { name: 'palletModel', source: '/assets/models/pallets/wooden_pallet.glb', type: 'model' },
            { name: 'boxModel', source: '/assets/models/boxes/cardboard_closed.glb', type: 'model' },
            { name: 'arrowModel', source: '/assets/models/miscellaneous/arrow.glb', type: 'model' },
        ]
    }
]